/**
 * @ngdoc module
 * @name runner.adapters
 * @module runner.adapters
 * @description Wrappers for global objects to make testing easier and depdencies more explicit
 */

angular.module('flowingly.runner.adapters', []);
